/* External */
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

/* Components */
import FocusableButton from '../../../components/FocusableButton/FocusableButton';
import { noOp } from '../../../utils/functions';

function Error({ focusKeyButton, onEnterPress }) {
  return (
    <div className="dtv-html5-c-pin-login__error">
      <p className="dtv-html5-c-pin-login__error-message">
        <FormattedMessage id="pinLogin.error.message" />
      </p>
      <FocusableButton
        focusKey={focusKeyButton}
        onEnterPress={onEnterPress}
        primary
      >
        <span><FormattedMessage id="pinLogin.error.retry" /></span>
      </FocusableButton>
    </div>
  );
}

Error.defaultProps = {
  focusKeyButton: '',
  onEnterPress: noOp,
};

Error.propTypes = {
  focusKeyButton: PropTypes.string,
  onEnterPress: PropTypes.func,
};

export default Error;
